import "../../CommonImports";
import "../../Core/core.css";
import "./Dialog.css";
import * as React from "react";
import { DialogInternal } from "./DialogInternal";
import { ContentJustification, ContentLocation } from '../../Callout';
import { css } from '../../Util';
export class CornerDialog extends React.Component {
    render() {
        return (React.createElement(DialogInternal, Object.assign({}, this.props, { calloutContentClassName: css(this.props.calloutContentClassName, "bolt-lower-right-corner-dialog-content"), calloutClassName: css(this.props.calloutClassName, "no-events"), contentJustification: ContentJustification.End, contentLocation: ContentLocation.End, lightDismiss: false, modal: false, escDismiss: false, showCloseButton: true })));
    }
}
